import React, { useState, useEffect } from "react";

const PaginationWithInput = ({
                                 totalPages,
                                 currentPage,
                                 onPageChange,
                             }) => {
    const [manualInput, setManualInput] = useState(currentPage);

    useEffect(() => {
        setManualInput(currentPage);
    }, [currentPage]);

    const handleManualSubmit = (e) => {
        e.preventDefault();
        const num = parseInt(manualInput);
        if (!isNaN(num) && num >= 1 && num <= totalPages) {
            onPageChange(num);
        }
    };

    const goToPrev = () => {
        if (currentPage > 1) onPageChange(currentPage - 1);
    };

    const goToNext = () => {
        if (currentPage < totalPages) onPageChange(currentPage + 1);
    };

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "10px",
                padding: "10px 0",
            }}
        >
            <button
                onClick={goToPrev}
                disabled={currentPage === 1}
                style={{ padding: "4px 8px" }}
            >
                &lt;
            </button>

            <div style={{ fontSize: "14px" }}>
                {currentPage} of {totalPages}
            </div>

            <button
                onClick={goToNext}
                disabled={currentPage === totalPages}
                style={{ padding: "4px 8px" }}
            >
                &gt;
            </button>

            <form onSubmit={handleManualSubmit} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <label style={{ fontSize: "14px" }}>Go to page:</label>
                <input
                    type="number"
                    value={manualInput}
                    onChange={(e) => setManualInput(e.target.value)}
                    min={1}
                    max={totalPages}
                    style={{
                        width: "60px",
                        padding: "4px",
                        fontSize: "14px",
                    }}
                />
                <button type="submit" style={{ padding: "4px 8px", fontSize: "14px" }}>
                    Go
                </button>
            </form>
        </div>
    );
};

export default PaginationWithInput;
